<template>
  <div class="pc:mx-auto pc:px-[140px] pc:max-w-[1366px]">
    <div class="flex justify-between items-center mobile:px-4">
      <div class="inline-flex items-center">
        <h2 class="text-[24px] font-bold mr-[6px]">{{ title }}</h2>
        <svg-icon :name="iconName"
                  size="37"></svg-icon>
      </div>


      <!-- 查看更多-->
      <div v-if="isMore"
           class="inline-flex items-center cursor-pointer"
           @click="moreSearch">
        <span class="mr-[7px] text-[16px] underline">{{ $t('sub_title.see_more') }}</span>
        <svg-icon name="arrow_circle_right"
                  size="24"></svg-icon>
      </div>

    </div>
    <h3 class="mobile:px-4 text-[16px]">{{ subTitle }}</h3>


    <div class="mt-[20px]">
      <!-- PC 且 1~4 個：依數量切版型填滿整列（1 個用橫向卡）。
           手機與 >4 個維持原本 swiper。圖片比例與卡片資料皆不變。 -->
      <div v-if="useGrid"
           class="grid gap-[14px]"
           :class="gridColsClass">
        <spaceCard v-for="item in displayList"
                   :key="item.id"
                   :space-card-obj="item"
                   :horizontal="spaceCardList.length === 1"
                   :fill-width="true"
                   :sizes="gridImageSizes"></spaceCard>
      </div>
      <swiper v-else
              :modules="[SwiperPagination]"
              :breakpoints="swiperBreakpoints"
              :pagination="isMobile">
        <swiper-slide v-for="item in displayList"
                      :key="item.id">
          <spaceCard :space-card-obj="item"></spaceCard>
        </swiper-slide>
      </swiper>
    </div>

  </div>
</template>
<script setup>
import {ref, watch, onMounted} from 'vue'
import spaceCard from './SpaceCard.vue'
import {computed} from "vue";
import {useSettingStore} from "@/stores/setting.js";
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useSearchWithStore, enrichAvailability} from "@/composables/useSearchWithStore";


// import {Swiper, SwiperSlide} from 'nuxt-swiper';
// import {Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import {useGoTo} from "@/composables/useGoTo";

const settingStore = useSettingStore()
const searchQueryStore = useSearchQueryStore()
const isMobile = computed(() => settingStore.isMobile);
const {handleSearchWithStore} = useSearchWithStore()
const {go} = useGoTo()

const swiperBreakpoints = ref({
  // 手機版
  1: {
    slidesPerView: 1.1,
    centeredSlides: true,
    spaceBetween: 8,
  },
  // pc版
  768: {
    slidesPerView: 4,
    centeredSlides: false,
    spaceBetween: 14,
  },

})


const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  subTitle: {
    type: String,
    default: ''
  },
  iconName: {
    type: String,
    default: ''
  },
  spaceCardList: {
    type: Array,
    default: []
  },
  isMore: {
    type: Boolean,
    default: false
  },
  moreSearchParam: {
    type: Object,
    default: {}
  }
})


// AV P2 刀2:首頁卡片檔期三態。SSR 首屏渲染原清單(與 server HTML 一致,不觸發 hydration mismatch),
// 客端 mount 後批次疊上 availability 再換上有徽章的清單。徽章是加分訊號,
// enrichAvailability 內部已 try/catch,失敗就維持原清單。
const displayList = ref(props.spaceCardList)

async function enrichDisplayList() {
  const list = props.spaceCardList
  if (!import.meta.client || !list?.length) return
  displayList.value = await enrichAvailability(list, '')
}

watch(() => props.spaceCardList, () => {
  displayList.value = props.spaceCardList
  enrichDisplayList()
})
onMounted(enrichDisplayList)

// PC（非手機）且 1~4 個 → 用 grid 依數量填滿整列；手機或 >4 個 → 維持 swiper。
const useGrid = computed(() => {
  const n = props.spaceCardList.length
  return !isMobile.value && n >= 1 && n <= 4
})

const gridColsClass = computed(() => {
  return {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
  }[props.spaceCardList.length] || 'grid-cols-4'
})

// 依版型給 NuxtImg 對應的來源寬度，避免寬卡放大模糊（卡片越少越寬）。
const gridImageSizes = computed(() => {
  const n = props.spaceCardList.length
  if (n <= 2) return '100vw md:520px' // 1 橫向(圖~45%)、2 欄
  if (n === 3) return '100vw md:400px'
  return '100vw md:259px'             // 4 欄，同原本
})

function moreSearch() {
  searchQueryStore.initQueryDate()
  searchQueryStore.setPagination(props.moreSearchParam.pagination)
  if (props.moreSearchParam.filter_options) {
    searchQueryStore.setFilterOptions(props.moreSearchParam.filter_options)
  }

  handleSearchWithStore()
  go('/search-result')
}


</script>
<style scoped
       lang="scss">
:deep(.swiper-pagination-bullet-active) {
  @apply bg-osn-yellow-00;
}

</style>
